<script setup lang="ts">
import type { IProps } from './Image.types'

const item = defineProps<IProps>()
const asset = item.data.data.target.fields
const isoCode = useI18n().locale.value === 'pl' ? 'pl-PL' : 'en-US'
const image = asset.image[isoCode][0]
const url = asset.url ? asset.url[isoCode] : undefined
const title = asset.title[isoCode]
const type = asset.type[isoCode][0]
const target = (type || 'internal') === 'external' ? '_blank' : '_self'
</script>

<template>
  <div class="articleImage">
    <template v-if="url">
      <a
        :href="url"
        :target="target"
        :title="title"
      >
        <NuxtImg
          class="articleImage__img"
          :src="image.secure_url"
          :alt="title"
          :title="title"
          lazy
        />
      </a>
    </template>
    
    <template v-else>
       <NuxtImg
          class="articleImage__img"
          :src="image.secure_url"
          :alt="title"
          :title="title"
          lazy
        />
    </template>
  </div>
</template>

<style lang="scss" scoped>
  .aticleImage {
    display: flex;
    align-items: center;
    width: 100%;

    &__img {
      max-width: 900px;
      width: 100%;
      margin: 40px auto;
      aspect-ratio: 16 / 9;
    }
  }
</style>
